import { CreateService, CRUDServiceInterface } from '@/services/service';
import { LessonTestQuestionEntity } from '@/entities/lesson-test-question.entity';

export default class LessonTestQuestionService
  extends CreateService<LessonTestQuestionEntity>('lesson-test-question')
  implements CRUDServiceInterface<LessonTestQuestionEntity>
{
  async getMany(): Promise<LessonTestQuestionEntity[]> {
    const [items] = await this.apiBuilder.getMany();
    return items;
  }

  async getManyByLessonId(
    id: string | number,
  ): Promise<LessonTestQuestionEntity[]> {
    this.apiBuilder.reset()
    const [items] = await this.apiBuilder
      .order('position', 'ASC')
      .filter('lessonId', '$eq', String(id))
      .getMany();
    return items;
  }
}
